"use strict";

export default [
  {
    path: "/",
    name: "landing",
    component: () => import("@/packages/public/views/Index"),
    meta: {
      title: "صفحه ی اصلی",
      headTags: [
        {
          name: "description",
          content: "مهرآوران دانش پژوهان البرز mdalborz ",
        },
      ],
    },
  },
  {
    path: "/about-us",
    name: "about",
    component: () => import("@/packages/public/views/aboutUs"),
    meta: {
      title: "درباره ی ما",
      headTags: [
        {
          name: "description",
          content:
            "موسسه مهرآوران دانش پژوهان البرز  به شماره ثبت55015 و شناسه ملی  14011843790   با استعانت از فرمایشات مقام معظم رهبری و با تابعیت از قوانین جمهوری اسلامی ایران در جهت کار افرینی و مهارت آموزش و ارتقا سطح دانش تخصصی، عملی، شغلی، مهارتی و کاربردی در زمینه اشتغال و ارتقا سطح دانش کاربردی در رشته های گوناگون اقدام به بر گزاری همایش ها و دوره ها و کارگاه ها با همکاری و مشارکت موسسات و ارگانها و مراکز آموزش و آموزشگاه ها در جهت ارائه همسطح سازی مدارک و سوابق شغلی، آموزشی، بیمه ای با ارائه گواهی نامه معادل دیپلم تا دکترا با گواهی نامه های با قابلیت ضدجعل نموده هست ",
        },
      ],
    },
  },
  {
    path: "/contact-us",
    name: "contact",
    component: () => import("@/packages/public/views/contactUs"),
    meta: {
      title: "تماس با ما",
      headTags: [
        {
          name: "description",
          content: "ارتباط با مهرآوران دانش پژوهان البرز",
        },
      ],
    },
  },
  {
    path: "/application-of-certificate",
    name: "application_certificate",
    component: () => import("@/packages/public/views/Application"),
    meta: {
      title: "استعلام مدرک",
      headTags: [
        {
          name: "description",
          content:
            "کاربرد گواهینامه معادل مهرآوران دانش پژوهان البرز ثبت شرکت در برخی موارد اخذ پروانه کسب از برخی اتحادیه ها, بالا بردن وجهه اجتماعی وپر کردن رزومه کاری",
        },
      ],
    },
  },
  {
    path: "/about-determining",
    name: "about_determining",
    component: () => import("@/packages/public/views/Determining"),
    meta: {
      title: "درباره ی تعیین سطح",
      headTags: [
        {
          name: "description",
          content: "درباره تعیین سطح مهرآوران دانش پژوهان البرز  توسعه ارتقاء سطح تخصصی و کاربردی با هدف کار آفرینی در شرایط کنونی یک امر حیاتی محسوب می شود، زیرا سرمایه گذاری‌های زیر بنایی و افزایش ابزار و تجهیزات و بطور کلی سرمایه‌های فیزیکی بدون سرمایه انسانی بلا استفاده خواهد ماند. زندگی شغلی افراد باید مولد و همراه با توسعه دانش کاربردی باشد تا قادر شوند با سرعت تغییر هماهنگ شوند، لذا داشتن دانش کاربردی برای موفقیت اقتصادی و اجتماعی افراد ضروری است",
        },
      ],
    },
  },
  {
    path: "/what-is-determining",
    name: "what_determining",
    component: () => import("@/packages/public/views/WhatDetermining"),
    meta: {
      title: "همسطح سازی چیست؟",
      headTags: [
        {
          name: "description",
          content: "ارزیابی، تجمیع و استاندارد سازی دوره های پودمانی آموزشی، دوره های ضمن خدمت، تجربیات و سوابق کاری، بیمه و مقالات‌ ، کتاب و تبدیل آن به گواهینامه‌های همسطح دیپلم تا دکتری و قابل استعلام از موسسه می باشد",
        },
      ],
    },
  },
  {
    path: "/condition",
    name: "condition",
    component: () => import("@/packages/public/views/Condition"),
    meta: {
      title: "شرایط صدور گواهی",
      headTags: [
        {
          name: "description",
          content: "شرایط صدور گواهی مهرآوران دانش پژوهان البرز",
        },
      ],
    },
  },
];
